<template>
  <div class="workOrderDetails">
    <div class="workOrderDetails_title">项目简介</div>
    <div class="workOrderDetails_box">
      <div class="workOrderDetails_box_title">{{ detailsInfo.taskName }}</div>
      <div class="workOrderDetails_box_content">
        <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" value-class="cell_value" title="工单："
          :value="detailsInfo.title" />
        <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" value-class="cell_value" title="成员："
          :value="detailsInfo.userName" />
        <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" value-class="cell_value" title="任务类型：">
          <template #default>
            <span v-if="detailsInfo.taskType == 1">开发</span>
            <span v-if="detailsInfo.taskType == 2">设计</span>
            <span v-if="detailsInfo.taskType == 3">测试</span>
          </template>
        </van-cell>
        <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" value-class="cell_value" title="计划开始时间："
          :value="detailsInfo.planStartTime" />
        <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" value-class="cell_value" title="计划结束时间："
          :value="detailsInfo.planEndTime" />
        <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" value-class="cell_value" title="实际开始时间："
          :value="detailsInfo.realStartTime" v-if="detailsInfo.realStartTime" />
        <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" value-class="cell_value" title="实际结束时间："
          :value="detailsInfo.realEndTime" v-if="detailsInfo.realEndTime" />
        <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" title="紧急程度：" value-class="cell_value">
          <template #default>
            <div class="time colorBoxBig">
              <span class="colorBox" v-if="detailsInfo.level == 1" style="background: #F56C6C;"></span>
              <span class="colorBox" v-if="detailsInfo.level == 2" style="background: #E6A23C;"></span>
              <span class="colorBox" v-if="detailsInfo.level == 3" style="background: #409EFF;"></span>
            </div>
          </template>
        </van-cell>
      </div>
    </div>
    <div class="workOrderDetails_box">
      <div class="workOrderDetails_box_title">状态</div>
      <div class="workOrderDetails_box_content">
        <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" value-class="cell_value" title="状态：">
          <template #default>
            <span class="workOrder_top_content_box_top_span">
              <el-tag v-if="detailsInfo.status == 1" size="small" type="info">待开始</el-tag>
              <el-tag v-if="detailsInfo.status == 2" size="small">进行中</el-tag>
              <el-tag v-if="detailsInfo.status == 3" size="small" type="success">已完成</el-tag>
              <el-tag v-if="detailsInfo.status == 4" size="small" type="warning">延期</el-tag>
              <el-tag v-if="detailsInfo.status == 5" size="small" type="danger">测试驳回</el-tag>
            </span>
          </template>
        </van-cell>
        <div class="workOrderDetails_box_content_content">
          <div class="workOrderDetails_box_content_content_box"
            v-if="detailsInfo.status == 3 && detailsInfo.rejectMessage">
            <span class="workOrderDetails_box_content_content_box_span">驳回原因：</span>
            <span class="workOrderDetails_box_content_content_box_span2">{{ detailsInfo.rejectMessage }}</span>
          </div>
          <div class="workOrderDetails_box_content_content_box"
            v-if="detailsInfo.status == 4 && detailsInfo.extensionMessage">
            <span class="workOrderDetails_box_content_content_box_span3">延期原因：</span>
            <span class="workOrderDetails_box_content_content_box_span2">{{ detailsInfo.extensionMessage }}</span>
          </div>
        </div>
        <div class="btnBox" v-if="status == 1 && notAuthorized == 1">
          <van-button type="default" round size="small" v-if="detailsInfo.status == 1"
            @click="upStatusFun(detailsInfo, 1, '开始')">开始</van-button>
          <van-button type="info" round size="small"
            v-if="detailsInfo.status == 2 || detailsInfo.status == 4 || detailsInfo.status == 5"
            @click="upStatusFun(detailsInfo, 2, '结束')">结束</van-button>
          <van-button type="info" round size="small"
            v-if="detailsInfo.status == 2 || detailsInfo.status == 4 || detailsInfo.status == 5"
            @click="upStatusFun(detailsInfo, 3, '延期')" color="#FF8165">延期</van-button>
          <van-button type="info" size="small" round v-if="detailsInfo.status == 3 && status != 2"
            @click="upStatusFun(detailsInfo, 4, '驳回')" color="#FF8165">驳回</van-button>
        </div>
        <van-button round color="linear-gradient(89deg, #3B87F7 0%, #67BDFF 100%)" block @click="getRecord()"
          style="margin-top: 20px;">操作记录</van-button>
      </div>
    </div>
    <van-popup v-model="show" position="bottom" @close="onClose" closeable>
      <div class="recordBox">
        <span class="recordBox_btn">操作记录</span>
        <el-steps direction="vertical" :active="taskRecordList.length">
          <el-step v-for="(item, index) in taskRecordList" :key="index">
            <div slot="title" class="">
              <span>{{ item.userName }} </span>
              <span style="font-size: 13px;">{{ item.createTime }}</span>
            </div>
            <div slot="description">
              <span>状态修改为了：</span>
              <span v-if="item.status == 1">待开始</span>
              <span v-if="item.status == 2">进行中</span>
              <span v-if="item.status == 3">已完成</span>
              <span v-if="item.status == 4">延期</span>
              <span v-if="item.status == 5">测试驳回</span>
            </div>
          </el-step>
        </el-steps>
      </div>
    </van-popup>
    <workTaskPop ref="workTaskPop" @ok="getDetalis()" />
  </div>
</template>

<script>
import { getTask, getOrder, listOperation } from '@/api/workOrder'
import workTaskPop from '@/views/signIn/workTaskPop'
import { Dialog } from 'vant';
import Cookies from 'js-cookie'
export default {
  name: "workOrder",
  components: { workTaskPop },
  data() {
    return {
      detailsInfo: {
        fileList: []
      },
      status: [],
      demandInfo: {},
      show: false,
      taskRecordList: [],
      notAuthorized: 0
    };
  },
  mounted() {
    // console.log(this.$route.params)companyId,userId
    this.getDetalis()
    this.notAuthorized = Cookies.get('notAuthorized')
  },
  methods: {
    getDetalis() {
      this.loading = true;
      getTask(this.$route.params.id).then(response => {
        let rows = response.data;
        if (rows.file) {
          rows.fileList = rows.file.split(',')
        } else {
          rows.fileList = []
        }
        this.detailsInfo = rows
        this.getDetalisFun(rows.orderId)
      });
    },
    getDetalisFun(id) {
      getOrder(id).then(response => {
        let rows = response.data;
        if (rows.file) {
          rows.fileList = rows.file.split(',')
        } else {
          rows.fileList = []
        }
        this.demandInfo = rows
        this.status = rows.status
        console.log(rows)
      });
    },
    getRecord() {
      this.show = true
      listOperation(
        {
          pageNum: 1,
          pageSize: 999,
          taskId: this.$route.params.id
        }
      ).then(response => {
        let rows = response.rows;
        this.taskRecordList = rows
      });
    },
    go(url) {
      if (window.__wxjs_environment === 'miniprogram') {
        // 页面 不会重新加载
        window.wx.miniProgram.navigateTo({
          url: '../public/downLoading?url=' + url,
        })
        // }, 100);
      } else {
        window.open(url)
        // alert('请在微信小程序中打开')
        // 页面会 重新加载(如:列表页 查看详情后会返回顶部)
        // this.$router.push(path);
      }
    },
    getCurrentDateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以需要加1
      const day = String(now.getDate()).padStart(2, '0');

      const hour = String(now.getHours()).padStart(2, '0');
      const minute = String(now.getMinutes()).padStart(2, '0');
      const second = String(now.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    // 修改状态
    upStatusFun(row, type, title) {
      this.statusTitle = title
      const that = this
      getTask(row.id).then(response => {
        this.form = response.data;
        if (type == 1) {
          this.statusType = 2
          this.form.realStartTime = this.getCurrentDateTime()
          Dialog.confirm({
            title: '标题',
            message: '是否确认开始',
          }).then(() => {
            const data = {}
            data.id = this.form.id
            data.status = this.statusType
            data.userId = Cookies.get("userId")
            data.userName = Cookies.get("NickName")
            data.rejectMessage = this.form.rejectMessage
            data.extensionMessage = this.form.extensionMessage
            data.realStartTime = this.form.realStartTime
            data.realEndTime = this.form.realEndTime
            updateStatus(data).then(response => {
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              this.statusOpen = false;
              this.getDemand();
            });
          }).catch(() => {
          });
        } else if (type == 2) {
          this.statusType = 3
          this.form.realEndTime = this.getCurrentDateTime()
          Dialog.confirm({
            title: '标题',
            message: '是否确认结束',
          }).then(() => {
            const data = {}
            data.id = this.form.id
            data.status = this.statusType
            data.userId = Cookies.get("userId")
            data.userName = Cookies.get("NickName")
            data.rejectMessage = this.form.rejectMessage
            data.extensionMessage = this.form.extensionMessage
            data.realStartTime = this.form.realStartTime
            data.realEndTime = this.form.realEndTime
            updateStatus(data).then(response => {
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              this.statusOpen = false;
              this.getDemand();
            });
          }).catch(() => {
          });
        } else if (type == 3) {
          this.$refs.workTaskPop.showForm(4, this.form, '延期')
        } else if (type == 4) {
          this.$refs.workTaskPop.showForm(5, this.form, '驳回')
        }
      });

    },
    onClose() {
      this.show = false
    }
  },
};
</script>
<style scoped>
.workOrderDetails {
  background-color: #F7F7F7;
}

.workOrderDetails_title {
  font-size: 19px;
  font-weight: 700;
  color: #1E1E1E;
  background-color: #fff;
  padding: 20px 20px 0;
}

.workOrderDetails_box {
  background-color: #fff;
  padding: 20px;
  margin-bottom: 15px;
}

.workOrderDetails_box_title {
  font-size: 18px;
  font-weight: 700;
  color: #333333;
  padding-left: 10px;
  position: relative;
  /* border-left: 4px solid #3B87F7; */
}

.workOrderDetails_box_title::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 21px;
  background-color: #3B87F7;
  position: absolute;
  left: 0;
  bottom: 1px;
}

.workOrderDetails_box_content {}

.colorBoxBig {
  align-items: center;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 11px;
  color: #999999;
  display: flex;
  align-items: flex-start;
}

.colorBox {
  display: inline-block;
  width: 25px;
  height: 13px;
  border-radius: 3px;
}

.colorBoxBig {
  align-items: center;
}

.cell_value {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  color: #333;
  font-weight: 700;
}

.workOrder_top_content_box_content_cell_title {
  color: #666666;
}

.workOrderDetails_box_content_content {}

.workOrderDetails_box_content_content_box {
  background-color: #F2F1F6;
  padding: 10px;
  border-radius: 4px;
  margin-top: 15px;
  display: flex;
  flex-direction: column;
}

.workOrderDetails_box_content_content_box_span {
  color: #FF8165;
}

.workOrderDetails_box_content_content_box_span3 {
  color: #FF8165;
}

.workOrderDetails_box_content_content_box_span2 {
  color: #666666;
  font-size: 15px;
  display: inline-block;
  margin-top: 10px;
}

.btnBox {
  padding: 20px 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.recordBox {
  padding: 20px;
}

.recordBox_btn {
  font-size: 19px;
  font-weight: 700;
  color: #333;
  display: inline-block;
  margin-bottom: 20px;
}
</style>
<style>
.workOrderDetails .van-cell {
  padding: 10px 0 0;
}

.btnBox .van-button {
  margin-left: 20px;
  min-width: 70px;
}
</style>